import { cx } from "@/utils/cx";
import type { ReactNode } from "react";

/**
 * Gymkee 2027 empty state (spec empty-state 1.7; sheet DS08).
 *
 * A heading, one line saying what goes here or what happened, and at most one action. No object
 * and no Dwayne anywhere in this app: rule 132 keeps the object family off a money surface, and
 * gate 15.5 keeps Dwayne off money and auth. No dashed box either; the sheet is the container.
 *
 * `inset` is the variant that lives inside a sheet or a section that already draws its own
 * hairline and ground, so the frame never doubles up (gate 6.2).
 */

export interface EmptyStateProps {
  heading: string;
  line?: ReactNode;
  /** One action, and only one; a second is the tell that the state is really two states. */
  action?: ReactNode;
  inset?: boolean;
  className?: string;
}

export function EmptyState({
  heading,
  line,
  action,
  inset = true,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cx(
        "ds-empty",
        inset ? "ds-pay-empty" : undefined,
        "gap-gk-4",
        className,
      )}
      role="status"
    >
      <p className="ds-empty-heading">{heading}</p>
      {line && <p className="ds-empty-line">{line}</p>}
      {action}
    </div>
  );
}
